import { membershipTypeMessages } from 'src/features/membershipType/utils/messages';
import { DURATION_UNIT, MEMBERSHIP_TEMPLATE_CATEGORY } from 'src/features/membershipType/types';
import { visitorMessages } from 'src/features/visitor/utils/messages';
import { BadgeOption } from 'src/registry/types/badges';
import { ICON_MAP } from 'src/utils/constants';
import { durationMessages, generalMessagesDays } from 'src/utils/messages';
import { DAY_OF_WEEK } from 'src/features/membershipType/types';
import { PERIOD_TYPE } from 'src/features/stay/types';
import { MessageDescriptor } from 'react-intl';

export const membershipTypeBadgeOptions: Record<MEMBERSHIP_TEMPLATE_CATEGORY, BadgeOption> = {
    [MEMBERSHIP_TEMPLATE_CATEGORY.VIP]: {
        label: visitorMessages.vip,
        icon: ICON_MAP.CLIENT,
        theme: 'green',
    },
    [MEMBERSHIP_TEMPLATE_CATEGORY.RESIDENT]: {
        label: visitorMessages.resident,
        icon: ICON_MAP.RESIDENT,
        theme: 'gray',
    },
    [MEMBERSHIP_TEMPLATE_CATEGORY.STAFF]: {
        label: visitorMessages.staff,
        icon: ICON_MAP.MEMBER,
        theme: 'blue',
    },
    [MEMBERSHIP_TEMPLATE_CATEGORY.SERVICE]: {
        label: visitorMessages.service,
        icon: ICON_MAP.SERVICE,
        theme: 'red',
    },
    [MEMBERSHIP_TEMPLATE_CATEGORY.SUBSCRIPTION]: {
        label: visitorMessages.subscription,
        icon: ICON_MAP.SUBSCRIPTION,
        theme: 'orange',
    },
    [MEMBERSHIP_TEMPLATE_CATEGORY.RESERVATION]: {
        label: visitorMessages.reservation,
        icon: ICON_MAP.RESERVATION,
        theme: 'purple',
    },
    [MEMBERSHIP_TEMPLATE_CATEGORY.CUSTOM]: {
        label: membershipTypeMessages.custom,
        icon: ICON_MAP.CUSTOM_TEMPLATE,
        theme: 'pink',
    },
};

export const MEMBERSHIP_TEMPLATE_TRANSLATION_MAP = {
    [MEMBERSHIP_TEMPLATE_CATEGORY.VIP]: visitorMessages.vip,
    [MEMBERSHIP_TEMPLATE_CATEGORY.RESIDENT]: visitorMessages.resident,
    [MEMBERSHIP_TEMPLATE_CATEGORY.STAFF]: visitorMessages.staff,
    [MEMBERSHIP_TEMPLATE_CATEGORY.SERVICE]: visitorMessages.service,
    [MEMBERSHIP_TEMPLATE_CATEGORY.SUBSCRIPTION]: visitorMessages.subscription,
    [MEMBERSHIP_TEMPLATE_CATEGORY.RESERVATION]: visitorMessages.reservation,
    [MEMBERSHIP_TEMPLATE_CATEGORY.CUSTOM]: membershipTypeMessages.custom,
};

export const DURATION_UNIT_TRANSLATION_MAP = {
    [DURATION_UNIT.HOUR]: durationMessages.hour,
    [DURATION_UNIT.DAY]: durationMessages.day,
    [DURATION_UNIT.WEEK]: durationMessages.week,
    [DURATION_UNIT.MONTH]: durationMessages.month,
    [DURATION_UNIT.YEAR]: durationMessages.year,
};

export const DURATION_UNIT_PLURAL_TRANSLATION_MAP = {
    [DURATION_UNIT.HOUR]: durationMessages.pluralHour,
    [DURATION_UNIT.DAY]: durationMessages.pluralDay,
    [DURATION_UNIT.WEEK]: durationMessages.pluralWeek,
    [DURATION_UNIT.MONTH]: durationMessages.pluralMonth,
    [DURATION_UNIT.YEAR]: durationMessages.pluralYear,
};

export const DAY_OF_WEEK_TRANSLATIONS_MAP = {
    [DAY_OF_WEEK.MONDAY]: generalMessagesDays.monday,
    [DAY_OF_WEEK.TUESDAY]: generalMessagesDays.tuesday,
    [DAY_OF_WEEK.WEDNESDAY]: generalMessagesDays.wednesday,
    [DAY_OF_WEEK.THURSDAY]: generalMessagesDays.thursday,
    [DAY_OF_WEEK.FRIDAY]: generalMessagesDays.friday,
    [DAY_OF_WEEK.SATURDAY]: generalMessagesDays.saturday,
    [DAY_OF_WEEK.SUNDAY]: generalMessagesDays.sunday,
};

export const zoneRuleStayTypeBadgeOptions: Record<PERIOD_TYPE, BadgeOption> = {
    [PERIOD_TYPE.STAY]: {
        label: visitorMessages.stay,
        icon: ICON_MAP.MEMBER,
        theme: 'blue',
    },
    [PERIOD_TYPE.TRANSIT]: {
        label: visitorMessages.transit,
        icon: ICON_MAP.RESIDENT,
        theme: 'gray',
    },
    [PERIOD_TYPE.EXIT]: {
        label: visitorMessages.exit,
        icon: ICON_MAP.ARROW_LEFT_FROM_ARC,
        theme: 'gray',
    },
};

export const zoneRuleStayTypeTranslationMap: Record<PERIOD_TYPE, MessageDescriptor> = {
    [PERIOD_TYPE.STAY]: visitorMessages.stay,
    [PERIOD_TYPE.TRANSIT]: visitorMessages.transit,
    [PERIOD_TYPE.EXIT]: visitorMessages.exit,
};
